import useOneToOne from "@/utils/hooks/useOneToOne.ts";
import List from "@edusogno/composites/list";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@edusogno/primitives/avatar";
import Button from "@edusogno/primitives/button";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@edusogno/primitives/toggle-group";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  onBack?: () => void;
  onNext?: (tutor_token: string) => void;
}

const SelectTutor = ({ onBack, onNext }: Props) => {
  const [tutorToken, setTutorToken] = useState<string>("");
  const { t } = useTranslation();
  const { tutorList, credits: stateCredits, setState } = useOneToOne();

  return (
    <>
      <div className={"flex flex-col gap-1 w-full mb-4"}>
        <h2 className={"text-xl font-semibold text-secondary "}>
          {t("one_to_one.select_tutor.header")}
        </h2>
        <p className={"text-base text-secondary"}>
          {t("one_to_one.select_tutor.subheader")}
        </p>
      </div>

      <List className={"w-full my-4"}>
        <ToggleGroup
          type={"single"}
          className={"flex flex-col gap-4 w-full h-full"}
          value={tutorToken}
          onValueChange={setTutorToken}
        >
          {tutorList.map((r) => (
            <ToggleGroupItem
              key={r?.token}
              value={r?.token}
              onClick={() => setState("tutorSelected", r)}
              className={
                "flex flex-row lg:gap-5 px-6 py-2 text-brand hover:bg-[--grey200] hover:text-brand data-[state=on]:[--color:white] [--color:--primary] data-[state=on]:bg-primary  data-[state=on]:text-white h-full justify-between rounded-md items-center center w-full bg-[--grey200]"
              }
            >
              <div className={"flex-row flex items-center gap-5"}>
                <Avatar className={"w-[49px] h-[49px]"}>
                  <AvatarImage src={r?.image} />
                  <AvatarFallback>
                    {r.name.slice(0, 2).toUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <p className={" text-xl font-bold"}>{r.name}</p>
              </div>
              <div
                className={
                  "flex flex-row !text-[--color] items-center gap-4 ml-4"
                }
              >
                <div
                  className={"flex !text-[--color] flex-row items-center gap-2"}
                >
                  {/*<svg*/}
                  {/*  xmlns="http://www.w3.org/2000/svg"*/}
                  {/*  width="17"*/}
                  {/*  height="16"*/}
                  {/*  viewBox="0 0 17 16"*/}
                  {/*  fill="none"*/}
                  {/*  className={"!text-[--color]"}*/}
                  {/*>*/}
                  {/*  <path*/}
                  {/*    d="M8.47387 0L11.562 4.39072L16.533 6.0872L13.4705 10.4973L13.4547 15.9365L8.47387 14.2713L3.49306 15.9365L3.47721 10.4973L0.414741 6.0872L5.38577 4.39072L8.47387 0Z"*/}
                  {/*    fill="currentColor"*/}
                  {/*  />*/}
                  {/*</svg>*/}
                  {/*<p className={"text-sm font-semibold"}>4.4</p>*/}
                </div>
                {/* <div
                  className={
                    "bg-white rounded-md text-xs text-brand flex flex-col py-2 px-6"
                  }
                >
                  <p className={"font-semibold text-start"}>
                    Last positive feedback:
                  </p>
                  <p className={"font-normal text-start line-clamp-2 h-full"}>
                    {r.positiveReview}
                  </p>
                </div> */}
              </div>
            </ToggleGroupItem>
          ))}
        </ToggleGroup>
      </List>
      <div className={"flex flex-row justify-center gap-2 w-full"}>
        <Button
          size={"md"}
          onClick={() => (onBack ? onBack() : null)}
          color={"white"}
        >
          {t("btns.back")}
        </Button>
        <Button
          size={"md"}
          disabled={!tutorToken || stateCredits === 0}
          onClick={() => (onNext ? onNext(tutorToken) : null)}
          color={"primary"}
        >
          {t("btns.next")}
        </Button>
      </div>
    </>
  );
};

export default SelectTutor;
